import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Info } from "lucide-react";

export const TYPES = ["Bezoek", "Bedrijfsbezoek (klant komt langs)", "Telefoon", "E-mail", "Overig"];
export const LOCATIES = ["Bij klant", "Bij Clazing", "Online", "Beurs", "Overig"];
export const KLANT_TYPES = ["Retail", "Foodservice", "Groothandel", "Private label", "Overig"];
export const KLANT_STATUS = ["Prospect", "Actief", "Inactief"];
export const PRIOS = ["Laag", "Normaal", "Hoog"];
export const STATUSSEN = ["Open", "Bezig", "Gereed"];
export const KANS_STATUS = ["Lead", "Offerte", "Gewonnen", "Verloren"];
export const AANVRAAG_STATUS = ["Nieuw", "In ontwikkeling", "Sample gemaakt", "Goedgekeurd", "Afgewezen", "Afgehandeld"];
export const ORDER_STATUS = ["Nieuw", "In productie", "Geleverd", "Gefactureerd", "Geannuleerd"];
export const FACTUUR_STATUS = ["Concept", "Verstuurd", "Betaald", "Geannuleerd"];

export const KANS_BADGE = { Lead: "bg-slate-100 text-slate-600", Offerte: "bg-amber-100 text-amber-700", Gewonnen: "bg-emerald-100 text-emerald-700", Verloren: "bg-rose-100 text-rose-700" };
export const AANVRAAG_BADGE = {
  Nieuw: "bg-amber-100 text-amber-700", "In ontwikkeling": "bg-sky-100 text-sky-700",
  "Sample gemaakt": "bg-indigo-100 text-indigo-700", Goedgekeurd: "bg-emerald-100 text-emerald-700",
  Afgewezen: "bg-rose-100 text-rose-700", Afgehandeld: "bg-slate-200 text-slate-600",
};
export const ORDER_BADGE = {
  Nieuw: "bg-amber-100 text-amber-700", "In productie": "bg-sky-100 text-sky-700",
  Geleverd: "bg-indigo-100 text-indigo-700", Gefactureerd: "bg-emerald-100 text-emerald-700",
  Geannuleerd: "bg-rose-100 text-rose-700",
};
export const FACTUUR_BADGE = {
  Concept: "bg-slate-100 text-slate-600", Verstuurd: "bg-amber-100 text-amber-700",
  Betaald: "bg-emerald-100 text-emerald-700", Geannuleerd: "bg-rose-100 text-rose-700",
};

export const fmtDate = (v) => (v ? new Date(v).toLocaleDateString("nl-NL", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—");
export const eur = (n) => "€ " + (Number(n) || 0).toLocaleString("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function isoWeekRange(d = new Date()) {
  const dt = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const day = (dt.getUTCDay() + 6) % 7;
  const mon = new Date(dt); mon.setUTCDate(dt.getUTCDate() - day);
  const sun = new Date(mon); sun.setUTCDate(mon.getUTCDate() + 6);
  return [mon.toISOString().slice(0, 10), sun.toISOString().slice(0, 10)];
}

export function daysUntil(v) {
  if (!v) return null;
  const d = new Date(String(v).slice(0, 10) + "T00:00:00Z");
  if (isNaN(d)) return null;
  const now = new Date(); const t = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
  return Math.round((d - t) / 86400000);
}

export function InfoHint({ text }) {
  return (<span title={text} className="ml-1 inline-flex h-4 w-4 cursor-help items-center justify-center rounded-full bg-slate-200 text-[10px] font-bold text-slate-500 align-middle">?</span>);
}

export function HelpBar({ children }) {
  return (
    <div className="flex items-start gap-2 rounded-md border border-sky-100 bg-sky-50/70 px-3 py-2 text-xs text-sky-800" data-testid="help-bar">
      <Info className="h-3.5 w-3.5 mt-0.5 shrink-0" /><div>{children}</div>
    </div>
  );
}

export function Field({ label, hint, children }) {
  return (
    <div>
      <label className="block text-xs font-semibold text-slate-600 mb-1">{label}{hint ? <InfoHint text={hint} /> : null}</label>
      {children}
    </div>
  );
}

export function KlantSelect({ klanten, value, onChange, testid }) {
  return (
    <Select value={value || "__none__"} onValueChange={(v) => onChange(v === "__none__" ? "" : v)}>
      <SelectTrigger data-testid={testid}><SelectValue placeholder="— kies klant —" /></SelectTrigger>
      <SelectContent>
        <SelectItem value="__none__">— kies klant —</SelectItem>
        {klanten.map((k) => <SelectItem key={k.id} value={k.code}>{k.code} — {k.naam}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export const klantNaamFrom = (klanten, code) => klanten.find((k) => k.code === code)?.naam || code || "—";
